export { default } from './UnscoredTableItemProductInfoSection'
